<div class="tw-reset tw-mx-4 tw-grid tw-h-dvh tw-place-items-center md:tw-mx-0">
  <div
    class="tw-absolute tw-top-14 tw-w-full tw-max-w-full tw-rounded-2xl tw-bg-white tw-p-6 tw-pb-4 tw-shadow-xl md:tw-max-w-md"
    role="dialog"
  >
    <h4 class="tw-mb-2 tw-font-extrabold tw-text-neutral-800">
      {{ headerText() }}
    </h4>
    <p [innerHTML]="bodyText()" class="tw-text-neutral-800"></p>
    <div class="tw-flex tw-w-full tw-justify-end tw-gap-4 tw-pt-6">
      <button
        type="button"
        class="tw-btn-medium tw-btn-secondary-filled"
        data-dgat="cancel-tag-rating-request-modal-67e"
        [attr.aria-label]="cancelButtonText()"
        (click)="cancel()"
      >
        {{ cancelButtonText() }}
      </button>
      <button
        type="button"
        class="tw-btn-primary tw-btn-medium"
        data-dgat="cancel-tag-rating-request-modal-631"
        [attr.aria-label]="submitText()"
        (click)="submit()"
      >
        {{ submitText() }}
      </button>
    </div>
  </div>
</div>
